var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"}],ref:"input",staticClass:"input-number",attrs:{"type":"text","readonly":_vm.readonly,"placeholder":_vm.placeholder},domProps:{"value":(_vm.number)},on:{"blur":_vm.formatValue,"change":_vm.onChange,"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08692424","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!../common/components/InputNumber.vue
// module id = 952
// module chunks = 1